import { useState } from 'react';
import cx from 'classnames';
import { useTranslations } from 'next-intl';
import CommonInput from '@/components/CommonInput';
import { checkOutSideVideo, CheckOutSideVideoStatus } from '@/api/video/parse';
import CommonModal from '../UploadCommonModal';
import Styles from './index.module.scss';

export interface ILinkModal {
  textId: string;
  onCancel: () => void;
  onChange: (textId: string, linkUrl: string, linkTitle: string) => void;
}

const LinkModal = ({
  textId,
  onCancel,
  onChange,
}: ILinkModal) => {
  const [linkUrl, setLinkUrl] = useState('');
  const [error, setError] = useState(false);
  const t = useTranslations();

  const handleSubmit = async () => {
    const data = await checkOutSideVideo({ url: linkUrl });
    if (data?.status !== CheckOutSideVideoStatus.success) {
      // 域名不在白名单内 OR 页面 404
      setError(true);
      return;
    }

    onChange(textId, data?.url || '', data?.title || '');
  };

  const handleChange = (val: string = '') => {
    setLinkUrl(val);
  };

  return (
    <CommonModal
      title={t("thread_add_link")}
      onCancel={onCancel}
      contentClassName={Styles.content}
    >
      <div className={Styles.main}>
        <div className={Styles.hintsWrapper}>
          <div className={Styles.hints}>{t('tips_thread_link')}</div>
        </div>
        <div className={Styles.input}>
          <CommonInput enableClear onChange={handleChange} className={Styles.inputWrapper} />
        </div>
        <div className={Styles.error}>{error ? t('error_link_url') : ''}</div>
        <div className={Styles.btnWrapper}>
          <button className={Styles.cancle} onClick={onCancel}>{t('btn_cancel')}</button>
          <button className={cx(Styles.sure, {[Styles.disabled]: !linkUrl})} onClick={!!linkUrl ? handleSubmit : undefined}>{t('btn_add')}</button>
        </div>
      </div>
    </CommonModal>
  );
};

export default LinkModal;
